import React from "react";

/**
 * React hook for responding to element size changes. Returns a ref to be attached to the element to be observed.
 * @param {function} handler - The callback function to be invoked by the observer
 */
export default function useResizeObserver(handler) {
    const ref = React.useRef();

    const observer = React.useMemo(() => {
        let task;
        return new ResizeObserver((entries, ...args) => {
            cancelAnimationFrame(task);
            task = requestAnimationFrame(() => {
                if (!Array.isArray(entries) || !entries.length) {
                    return;
                }
                void handler?.(entries, ...args);
            });
        });
    }, [handler]);

    React.useEffect(() => {
        if (ref.current) {
            observer.observe(ref.current);
        }
        return () => observer.disconnect();
    }, [observer]);

    return ref;
}
